// hooks/useCreateLuraSignUser.ts
import { useAtomValue } from 'jotai';
import { createLuraSignUserAtom } from '../../store/global/atoms';

export const useCreateLuraSignUser = () => { 
  const createLuraSignUserData = useAtomValue(createLuraSignUserAtom);

  return {
    createdUserData: createLuraSignUserData.data,
    createLuraSignUser: createLuraSignUserData.mutate,
    createLuraSignUserAsync: createLuraSignUserData.mutateAsync,
    isLoading: createLuraSignUserData.isPending,
    error: createLuraSignUserData.error,
  };
};